import * as THREE from "three";
import { params, const_var, initialState } from "../reducer";
import { calcOverhangSize } from "../../../helpers/building_component/buildingComponent.helper";
import * as cuComponent from "../building_component/componentReducer";
import * as utlis from "../utils";
import { commonFunctionForColor } from "../../../helpers/common/common.helper";
import { LEAN_TYPE_NUM_TO_STR, ManufacturesDefaultDetails } from "../../../Constants/constant";
import { createCompareLeanPricingHelpers } from "../../../helpers/building_comparison_pricing/compareLeanPricing.helper";
import { createLegsConditionHelpers } from "../../../helpers/building_component/legs_condition.helper";
import { createLeanBuildingPriceCalculationHelpers } from "../../../helpers/lean_building_pricing/leanBuildingPriceCalculation.helper";
import { createCenterBuildingPriceCalculationHelpers } from "../../../helpers/building_pricing/centerBuildingPriceCalculation.helper";
import { getSidingOrientationOptions, setDefaultBuildingMaterialById } from "../../../helpers/building/building_material/buildingMaterial.helper";
import { applyColorToParams, getBuildingColor, setDefaultBuildingColorById } from "../../../helpers/building/building_color/building.color.helper";
import { setDefaultLeanToData } from "../../../helpers/lean_building_pricing/leanBuilding.helper";
import { updateWallSelection } from "../../../helpers/building_pricing/wall_pricing/wallPricing.helper";
import { calculateLeanWallData, finalizeLeanUpdate, updateLeanWallData } from "../../../helpers/lean_building_pricing/lean_building_wall/leanBuildingWall.helper";

const pricingReducer = (state = initialState, action) => {
	const newState = { ...state };
	return newState;
};

const setInsulation = (b) => {
	if (const_var.isLTBuilding) {
		if (parseFloat(b.insulation_price) > 0) {
			b.insulation = "custom";
		}
	}
};

export const BuildingUpdate = (Val, newFlag) => {
	if (params.m_s_n == 122) {
		if (params.add_front_lean == false && (params.p_f_w == "Half_Close" || params.p_f_w == "One_Fourth_Close" || params.p_f_w == "Three_Fourth_Close")) {
			params.p_f_w = "Open";
		}
		if (params.add_back_lean == false && (params.p_b_w == "Half_Close" || params.p_b_w == "One_Fourth_Close" || params.p_b_w == "Three_Fourth_Close")) {
			params.p_b_w = "Open";
		}
		if (params.add_left_lean == false && (params.p_l_w == "Half_Close" || params.p_l_w == "One_Fourth_Close" || params.p_l_w == "Three_Fourth_Close")) {
			params.p_l_w = "Open";
		}
		if (params.add_right_lean == false && (params.p_r_w == "Half_Close" || params.p_r_w == "One_Fourth_Close" || params.p_r_w == "Three_Fourth_Close")) {
			params.p_r_w = "Open";
		}
	}
	if (params.add_left_lean == true && params.p_l_w != "Close") {
		var pitchCalulation = (params.lean_p_w * params.b_l_t_r_p) / 12;
		var calData = params.leanStyle.left === "gable" ? 0 : (params.lean_p_w * params.b_l_t_r_p) / 12;
		var finalHeight = params.leanStyle.left === "gable" ? params.p_h - params.lean_p_h : params.p_h - (calData + params.lean_p_h);
		var calVal = Math.ceil(finalHeight / 3);
		var oneFourthValue = params.p_h / 4;
		var halfCloseValue = params.p_h / 2;
		if (oneFourthValue < finalHeight && halfCloseValue < finalHeight && params.p_l_w !== "Three_Fourth_Close" /*|| (2 * oneFourthValue) < finalHeight || (3 * oneFourthValue) < finalHeight */) {
			params.p_l_w = params.p_l_w > calVal ? params.p_l_w : calVal.toString();
		}
		if (calVal != 0 && params.p_l_w !== "Half_Close" && params.p_l_w !== "One_Fourth_Close" && params.p_l_w !== "Three_Fourth_Close") {
			if (params.p_h == calData + params.lean_p_h) {
				params.p_l_w = "Open";
			} else {
				if (const_var.a_p_d_a.length > 0 && const_var.a_p_d_a.panel.length == 0) {
					params.p_l_w = "Close";
				} else if (params.p_h > const_var.b_m_i_hlean + Number(params.b_l_t_r_p)) {
					params.p_l_w = params.p_l_w > calVal ? params.p_l_w : calVal.toString();
					if (const_var.checkPanelForLean.left === false) {
						const_var.checkPanelForLean.left = true;
					}
				}
				let hdfp = params.p_h - (params.lean_p_h + (parseInt(params.b_l_t_r_p) / 12) * params.lean_p_w);
				if (params.add_left_lean && hdfp > 0 && Math.abs(params.p_l_w) * 3 - hdfp < 3) {
					const_var.checkPanelForLean.left = true;
				}
			}
		} else {
			if (params.p_l_w == "Half_Close" || params.p_l_w == "One_Fourth_Close" || params.p_l_w == "Three_Fourth_Close") {
				params.p_l_w = params.a_c_p_l == true ? params.p_l_w : params.p_l_w;
			} else if (params.p_h > const_var.b_m_i_hlean + Number(params.b_l_t_r_p)) {
				params.p_l_w = params.a_c_p_l == true ? params.p_l_w : "Open";
			}
		}
	}
	// ------- SE3-I6147 -> Additional wall options under insulation for building 2 isn't coming correct ------//
	if (const_var.isLTBuilding && params.leanStyle.left == "gable") {
		const is_GableLeanBackWall = params.leanStyle.left !== "gable" || (params.leanStyle.left === "gable" && params.p_l_w !== "Close");
		if (params.p_l_w == "Close" && const_var.wallsData?.leftLean?.p_b_c_b_l_b) {
			delete const_var.wallsData.leftLean.p_b_c_b_l_b;
		}
		if (params.p_b_c_b_l == "Close" && (!is_GableLeanBackWall || params.p_b_c_b_l_b == "Close") && params.p_b_c_b_l_f == "Close" && params.p_b_c_b_l_r == "Close") {
			const_var.setLeanWallOption.leftLean = "close";
		} else if (params.p_b_c_b_l == "Open" && params.p_b_c_b_l_b == "Open" && params.p_b_c_b_l_f == "Open" && params.p_b_c_b_l_r == "Open") {
			const_var.setLeanWallOption.leftLean = "open";
		} else {
			const_var.setLeanWallOption.leftLean = "partial";
		}
	}
	//--------------------------------------------------------------------//
	if (params.add_right_lean == true && params.p_r_w != "Close") {
		var pitchCalulation = (params.leanR_p_w * params.b_l_t_r_pR) / 12;
		var calData = params.leanStyle.right === "gable" ? 0 : (params.leanR_p_w * params.b_l_t_r_pR) / 12;
		var finalHeight = params.leanStyle.right === "gable" ? params.p_h - params.leanR_p_h : params.p_h - (calData + params.leanR_p_h);
		var calVal = Math.ceil(finalHeight / 3);
		var oneFourthValue = params.p_h / 4;
		var oneFourthValue = params.p_h / 2;
		var halfCloseValue = params.p_h / 2;
		if (oneFourthValue < finalHeight && halfCloseValue < finalHeight && params.p_r_w !== "Three_Fourth_Close" /*|| (2 * oneFourthValue) < finalHeight || (3 * oneFourthValue) < finalHeight*/) {
			params.p_r_w = params.p_r_w > calVal ? params.p_r_w : calVal.toString();
		}
		if (calVal != 0 && params.p_r_w !== "Half_Close" && params.p_r_w !== "One_Fourth_Close" && params.p_r_w !== "Three_Fourth_Close") {
			if (params.p_h == calData + params.leanR_p_h) {
				params.p_r_w = "Open";
			} else {
				if (const_var.a_p_d_a.length > 0 && const_var.a_p_d_a.panel.length == 0) {
					params.p_r_w = "Close";
				} else {
					params.p_r_w = params.p_r_w > calVal ? params.p_r_w : calVal.toString();
					if (const_var.checkPanelForLean.right === false) {
						const_var.checkPanelForLean.right = true;
					}
				}
				let hdfp = params.p_h - (params.leanR_p_h + (parseInt(params.b_l_t_r_pR) / 12) * params.leanR_p_w);
				if (params.add_right_lean && hdfp > 0 && Math.abs(params.p_r_w) * 3 - hdfp < 3) {
					const_var.checkPanelForLean.right = true;
				}
			}
		} else {
			if (params.p_r_w == "Half_Close" || params.p_r_w == "One_Fourth_Close" || params.p_r_w == "Three_Fourth_Close") {
				params.p_r_w = params.a_c_p_r == true ? params.p_r_w : params.p_r_w;
			} else {
				params.p_r_w = params.a_c_p_r == true ? params.p_r_w : "Open";
			}
		}
	}
	// ------- SE3-I6147 -> Additional wall options under insulation for building 2 isn't coming correct ------//
	if (const_var.isLTBuilding && params.leanStyle.right == "gable") {
		const is_GableLeanBackWall = params.leanStyle.right !== "gable" || (params.leanStyle.right === "gable" && params.p_r_w !== "Close");
		if (params.p_r_w == "Close" && const_var.wallsData?.rightLean?.p_b_c_b_r_b) {
			delete const_var.wallsData.rightLean.p_b_c_b_r_b;
		}
		if (params.p_b_c_b_r == "Close" && (!is_GableLeanBackWall || params.p_b_c_b_r_b == "Close") && params.p_b_c_b_r_f == "Close" && params.p_b_c_b_r_r == "Close") {
			const_var.setLeanWallOption.rightLean = "close";
		} else if (params.p_b_c_b_r == "Open" && params.p_b_c_b_r_b == "Open" && params.p_b_c_b_r_f == "Open" && params.p_b_c_b_r_r == "Open") {
			const_var.setLeanWallOption.rightLean = "open";
		} else {
			const_var.setLeanWallOption.rightLean = "partial";
		}
	}
	//---------------------------------------------------------------------------//
	if (params.add_front_lean == true) {
		let mainIndexF;
		let fHight = params.leanStyle.front === "standard" ? params.p_h - (params.leanF_p_h + (parseInt(params.b_l_t_r_pF) / 12) * params.leanF_p_w) : params.p_h - params.leanF_p_h;

		let orignalObj = const_var.wallArray["front"];
		let orignalObjKeys = Object.keys(const_var.wallArray["front"]);
		let fristAvailableKey = orignalObjKeys.includes("Open") ? orignalObj[orignalObjKeys[1]] : orignalObj[orignalObjKeys[0]];

		Object.entries(const_var.wallArray["front"]).forEach(([key, value], index) => {
			if (fHight < 2.5 && const_var.a_p_d_a.gable_end != undefined && const_var.a_p_d_a.gable_end.length > 0) {
				if (params.leanStyle.front === "gable" && params.p_h === params.leanF_p_h && params.p_w === params.leanF_p_w && params.p_r_p == params.b_l_t_r_pF) {
					params.p_f_wF = "Open";
				} else {
					params.p_f_wF = "Gable";
				}
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			} else if (fHight >= 2.5 && fHight <= 3.5 && const_var.a_p_d_a.gable_end[0] != undefined && (const_var.a_p_d_a.gable_end[0].extended != 0 || const_var.a_p_d_a.gable_end[0].vertical_extended != 0)) {
				params.p_f_wF = "Extended Gable";
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			} else if (
				(fHight > 3.5 && fHight <= params.p_h / 4) ||
				(fristAvailableKey == "One_Fourth_Close" && fHight <= 3.5) ||
				(const_var.a_p_d_a.gable_end[0] != undefined && fHight >= 2.5 && fHight <= 3.5 && const_var.a_p_d_a.gable_end[0].extended == 0) ||
				(const_var.a_p_d_a.gable_end[0] != undefined && fHight >= 2.5 && fHight <= 3.5 && const_var.a_p_d_a.gable_end[0].vertical_extended == 0)
			) {
				params.p_f_wF = "One_Fourth_Close";
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			} else if ((fHight > params.p_h / 4 && fHight <= params.p_h / 2) || (fristAvailableKey == "Half_Close" && fHight <= params.p_h / 4)) {
				params.p_f_wF = "Half_Close";
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			} else if ((fHight > params.p_h / 2 && fHight <= params.p_h * (3 / 4)) || (fristAvailableKey == "Three_Fourth_Close" && fHight <= params.p_h / 2)) {
				params.p_f_wF = "Three_Fourth_Close";
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			} else {
				params.p_f_wF = "Close";
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			}
		});

		if (Object.values(const_var.wallArray["front"]).includes(params.p_f_w) == false && Object.values(const_var.wallArray["front"]).length != 0) {
			params.p_f_w = params.p_f_wF;
		}
	}
	if (params.add_back_lean == true) {
		let bHight = params.leanStyle.back === "standard" ? params.p_h - (params.leanB_p_h + (parseInt(params.b_l_t_r_pB) / 12) * params.leanB_p_w) : params.p_h - params.leanB_p_h;
		let mainIndexB;
		Object.entries(const_var.wallArray["back"]).forEach(([key, value], index) => {
			let orignalObj = const_var.wallArray["back"];
			let orignalObjKeys = Object.keys(const_var.wallArray["back"]);
			let fristAvailableKey = orignalObjKeys.includes("Open") ? orignalObj[orignalObjKeys[1]] : orignalObj[orignalObjKeys[0]];

			if (bHight < 2.5 && const_var.a_p_d_a.gable_end != undefined && const_var.a_p_d_a.gable_end.length > 0) {
				if (params.leanStyle.back === "gable" && params.p_h === params.leanB_p_h && params.p_w === params.leanB_p_w && params.p_r_p == params.b_l_t_r_pB) {
					params.p_b_wB = "Open";
				} else {
					params.p_b_wB = "Gable";
				}
				if (params.p_b_wB == value) {
					mainIndexB = index;
				}
				if (index >= mainIndexB) {
					const_var.wallArray["back"][key] = value;
				} else {
					delete const_var.wallArray["back"][key];
				}
			} else if (bHight >= 2.5 && bHight <= 3.5 && const_var.a_p_d_a.gable_end[0] != undefined && (const_var.a_p_d_a.gable_end[0].extended != 0 || const_var.a_p_d_a.gable_end[0].vertical_extended != 0)) {
				params.p_b_wB = "Extended Gable";
				if (params.p_b_wB == value) {
					mainIndexB = index;
				}
				if (index >= mainIndexB) {
					const_var.wallArray["back"][key] = value;
				} else {
					delete const_var.wallArray["back"][key];
				}
			} else if (
				(bHight > 3.5 && bHight <= params.p_h / 4) ||
				(fristAvailableKey == "One_Fourth_Close" && bHight <= 3.5) ||
				(const_var.a_p_d_a.gable_end[0] != undefined && bHight >= 2.5 && bHight <= 3.5 && const_var.a_p_d_a.gable_end[0].extended == 0) ||
				(const_var.a_p_d_a.gable_end[0] != undefined && bHight >= 2.5 && bHight <= 3.5 && const_var.a_p_d_a.gable_end[0].vertical_extended == 0)
			) {
				params.p_b_wB = "One_Fourth_Close";
				if (params.p_b_wB == value) {
					mainIndexB = index;
				}
				if (index >= mainIndexB) {
					const_var.wallArray["back"][key] = value;
				} else {
					delete const_var.wallArray["back"][key];
				}
			} else if ((bHight > params.p_h / 4 && bHight <= params.p_h / 2) || (fristAvailableKey == "Half_Close" && bHight <= params.p_h / 4)) {
				params.p_b_wB = "Half_Close";
				if (params.p_b_wB == value) {
					mainIndexB = index;
				}
				if (index >= mainIndexB) {
					const_var.wallArray["back"][key] = value;
				} else {
					delete const_var.wallArray["back"][key];
				}
			} else if ((bHight > params.p_h / 2 && bHight <= params.p_h * (3 / 4)) || (fristAvailableKey == "Three_Fourth_Close" && bHight <= params.p_h / 2)) {
				params.p_b_wB = "Three_Fourth_Close";
				if (params.p_b_wB == value) {
					mainIndexB = index;
				}
				if (index >= mainIndexB) {
					const_var.wallArray["back"][key] = value;
				} else {
					delete const_var.wallArray["back"][key];
				}
			} else {
				params.p_b_wB = "Close";
				if (params.p_b_wB == value) {
					mainIndexB = index;
				}
				if (index >= mainIndexB) {
					const_var.wallArray["back"][key] = value;
				} else {
					delete const_var.wallArray["back"][key];
				}
			}
		});

		if (Object.values(const_var.wallArray["back"]).includes(params.p_b_w) == false && Object.values(const_var.wallArray["back"]).length != 0) {
			params.p_b_w = params.p_b_wB;
		}
	}
	if (
		params.p_f_w == "Close" ||
		params.p_f_w == "Half Dutch End" ||
		params.p_f_w == "Half End" ||
		params.p_b_w == "Half Dutch End" ||
		params.p_b_w == "Half End" ||
		params.p_b_w == "Close" ||
		params.p_l_w == "Close" ||
		params.p_r_w == "Close" ||
		params.p_b_c_b_l_f == "Close" ||
		params.p_b_c_b_l == "Close" ||
		params.p_b_c_b_r_f == "Close" ||
		params.p_b_c_b_r == "Close" ||
		params.p_b_c_b_f_f == "Close" ||
		params.p_b_c_b_f_b == "Close" ||
		params.p_b_c_b_f_l == "Close" ||
		params.p_b_c_b_b_f == "Close" ||
		params.p_b_c_b_b_b == "Close" ||
		params.p_b_c_b_b_l == "Close" ||
		params.p_b_c_b_b_r == "Close" ||
		params.p_b_c_b_l_r == "Close" ||
		params.p_b_c_b_f_r == "Close" ||
		params.p_b_c_b_r_r == "Close" ||
		params.add_storage_check == true ||
		params.add_storage_check_right == true ||
		params.add_storage_check_front == true ||
		params.add_storage_check_back == true ||
		params.p_u_c == true ||
		params.cB_addStorage_check_right == true ||
		params.cB_addStorage_check_left == true ||
		params.p_b_c_b_l_f == "Half Dutch End" ||
		params.p_b_c_b_l_f == "Half End" ||
		params.p_b_c_b_l_b == "Half Dutch End" ||
		params.p_b_c_b_l_b == "Half End" ||
		params.p_b_c_b_b_f == "Half Dutch End" ||
		params.p_b_c_b_b_f == "Half End" ||
		params.p_b_c_b_b_b == "Half Dutch End" ||
		params.p_b_c_b_b_b == "Half End" ||
		params.p_b_c_b_f_f == "Half Dutch End" ||
		params.p_b_c_b_f_f == "Half End" ||
		params.p_b_c_b_f_b == "Half Dutch End" ||
		params.p_b_c_b_f_b == "Half End" ||
		params.p_b_c_b_r_f == "Half Dutch End" ||
		params.p_b_c_b_r_f == "Half End" ||
		params.p_b_c_b_r_b == "Half Dutch End" ||
		params.p_b_c_b_r_b == "Half End"
	) {
		const_var.showWainscotJSX = true;
	} else {
		const_var.showWainscotJSX = false;
		params.p_w_c_n = false;
	}
	if (
		params.p_f_w != "Open" ||
		params.p_b_w != "Open" ||
		params.p_l_w != "Open" ||
		params.p_r_w != "Open" ||
		params.p_b_c_b_l_f != "Open" ||
		params.p_b_c_b_l != "Open" ||
		params.p_b_c_b_r_f != "Open" ||
		params.p_b_c_b_r != "Open" ||
		params.p_b_c_b_f_f != "Open" ||
		params.p_b_c_b_f_b != "Open" ||
		params.p_b_c_b_f_l != "Open" ||
		params.p_b_c_b_b_f != "Open" ||
		params.p_b_c_b_b_b != "Open" ||
		params.p_b_c_b_b_l != "Open" ||
		params.p_b_c_b_b_r != "Open" ||
		params.p_b_c_b_l_r != "Open" ||
		params.p_b_c_b_f_r != "Open" ||
		params.p_b_c_b_r_r != "Open" ||
		params.p_u_c == true ||
		params.add_storage_check == true ||
		params.add_storage_check_right == true ||
		params.add_storage_check_front == true ||
		params.add_storage_check_back == true ||
		params.p_c_p_l == true ||
		params.p_c_p_r == true
	) {
		const_var.showWallColorJSX = true;
	} else {
		const_var.showWallColorJSX = false;
	}

	let closedEndWalls = 0;
	let closedSideWalls = 0;
	let fullclosedEndWalls = 0;
	let fullclosedSideWalls = 0;
	if (params.cB_addStorage_check_left) {
		params.p_l_w = "Close";
	}
	if (params.cB_addStorage_check_right) {
		params.p_r_w = "Close";
	}
	if (params.p_f_w != "Open") {
		closedEndWalls = closedEndWalls + 1;
	}
	if (params.p_b_w != "Open") {
		closedEndWalls = closedEndWalls + 1;
	}
	let frontWallValue = "";
	if (newFlag == "centerwall") {
		frontWallValue = params.p_f_w;
	}
	if (params.p_u_c == true) {
		if (params.endStoragePositionZ === 0) params.p_b_w = "Close";

		if (params.endStoragePositionZ === params.p_d - params.p_u_t) {
			params.p_f_w = "Close";
		} else if (params.endStoragePositionZ != params.p_d - params.p_u_t && params.prev_p_f_w != undefined) {
		}

		if (newFlag == "centerwall") {
			params.p_f_w = frontWallValue;
		}
		if (params.endStoragePositionZ != 0 && params.endStoragePositionZ != params.p_d - params.p_u_t) {
			closedEndWalls += 2;
		} else {
			closedEndWalls = closedEndWalls + 1;
		}
		closedSideWalls = 2;
		if (params.p_l_w != "Open") closedSideWalls = closedSideWalls - 1;
		if (params.p_r_w != "Open") closedSideWalls = closedSideWalls - 1;
	}
	if (params.p_l_w != "Open") {
		closedSideWalls = closedSideWalls + 1;
	}
	if (params.p_r_w != "Open") {
		closedSideWalls = closedSideWalls + 1;
	}
	if (params.cB_addStorage_check_left || params.cB_addStorage_check_right) {
		closedSideWalls = closedSideWalls + 1;
		closedEndWalls = 2;
	}

	if (params.p_f_w == "Close") {
		fullclosedEndWalls = fullclosedEndWalls + 1;
	}
	if (params.p_b_w == "Close") {
		fullclosedEndWalls = fullclosedEndWalls + 1;
	}
	if (params.p_u_c == true) {
		fullclosedEndWalls = fullclosedEndWalls + 1;
		fullclosedSideWalls = 2;
		if (params.p_l_w == "Close") fullclosedSideWalls = fullclosedSideWalls - 1;
		if (params.p_r_w == "Close") fullclosedSideWalls = fullclosedSideWalls - 1;
	}
	if (params.p_l_w == "Close") {
		fullclosedSideWalls = fullclosedSideWalls + 1;
	}
	if (params.p_r_w == "Close") {
		fullclosedSideWalls = fullclosedSideWalls + 1;
	}
	if (params.cB_addStorage_check_left || params.cB_addStorage_check_right) {
		fullclosedSideWalls = fullclosedSideWalls + 1;
		fullclosedEndWalls = 2;
	}

	if (params.p_f_w === "Close" && params.p_r_w === "Close" && params.p_l_w === "Close" && params.p_b_w === "Close") {
		const_var.setSidesEndsWallOption = "close";
	} else if (params.p_f_w === "Open" && params.p_r_w === "Open" && params.p_l_w === "Open" && params.p_b_w === "Open" && params.p_c_p_l == false && params.p_c_p_r == false) {
		const_var.setSidesEndsWallOption = "open";
	} else {
		const_var.setSidesEndsWallOption = "partial";
	}
	const_var.wallsData.center.closedEndWalls = closedEndWalls;
	const_var.wallsData.center.closedSideWalls = closedSideWalls;

	const_var.wallsData.center.fullclosedEndWalls = fullclosedEndWalls;
	const_var.wallsData.center.fullclosedSideWalls = fullclosedSideWalls;

	const_var.wallsData.center.p_f_w = params.p_f_w;
	const_var.wallsData.center.p_b_w = params.p_b_w;
	const_var.wallsData.center.p_l_w = params.p_l_w;
	const_var.wallsData.center.p_r_w = params.p_r_w;
	/* to identify the Continous Building (start)*/
	const_var.ContinousRoofCount = 0;
	let leftLeanCheck = params.p_h == Math.round(params.lean_p_h + (params.lean_p_w * params.b_l_t_r_p) / 12);
	let rightLeanCheck = params.p_h == Math.round(params.leanR_p_h + (params.leanR_p_w * params.b_l_t_r_pR) / 12);

	if ((leftLeanCheck && !rightLeanCheck) || (!leftLeanCheck && rightLeanCheck)) const_var.ContinousRoofCount = 1;
	else if (leftLeanCheck && rightLeanCheck) const_var.ContinousRoofCount = 2;
	/* to identify the Continous Building (end)*/
	let legDistance;
	if (params.fourth_center_cost == true) {
		if (const_var.DistanceArr.length > 0 && const_var.DistanceArr[params.p_b_t][params.p_r_s] != undefined) {
			if (const_var.isUpdate4ftLegLogic) {
				legDistance = params.oncenter_val_with_action != "" ? params.p_d / parseFloat(params.oncenter_val_with_action) : params.p_d / parseFloat(const_var.DistanceArr[params.p_b_t][params.p_r_s]);
				legDistance = Math.ceil(legDistance);
			} else {
				legDistance =
					params.oncenter_val_with_action != "" ? (params.p_d / parseInt(params.oncenter_val_with_action)).toFixed(0) : (params.p_d / parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
			}
		}
	} else {
		if (const_var.DistanceArr.length > 0 && const_var.DistanceArr[params.p_b_t][params.p_r_s] != undefined) {
			if (const_var.isUpdate4ftLegLogic) {
				legDistance = params.oncenter_val_with_action != "" ? params.p_d / parseFloat(params.oncenter_val_with_action) : params.p_d / parseFloat(const_var.DistanceArr[params.p_b_t][params.p_r_s]);
				legDistance = Math.ceil(legDistance);
			} else {
				legDistance =
					params.oncenter_val_with_action != "" ? (params.p_d / parseInt(params.oncenter_val_with_action)).toFixed(0) : (params.p_d / parseInt(const_var.DistanceArr[params.p_b_t][params.p_r_s])).toFixed(0);
			}
		}
	}
	const_var.count_numberofLegs = parseFloat(legDistance) + 1;

	updateWallSelection();
};
export const UpdateLeftLean = (type) => {
	if (params.add_left_lean == true && params.p_l_w != "Close") {
		var calData = params.leanStyle.left === "gable" ? 0 : (params.lean_p_w * params.b_l_t_r_p) / 12;
		var finalHeight = params.leanStyle.left === "gable" ? params.p_h - params.lean_p_h : params.p_h - (calData + params.lean_p_h);
		var calVal = Math.ceil(finalHeight / 3);
		var oneFourthValue = params.p_h / 4;
		var halfCloseValue = params.p_h / 2;
		if (oneFourthValue < finalHeight && halfCloseValue < finalHeight && params.p_l_w !== "Three_Fourth_Close") {
			params.p_l_w = params.p_l_w > calVal ? params.p_l_w : calVal.toString();
		}
		if (calVal > 0 && params.p_l_w !== "Half_Close" && params.p_l_w !== "One_Fourth_Close" && params.p_l_w !== "Three_Fourth_Close") {
			if (params.p_h == calData + params.lean_p_h) {
				params.p_l_w = "Open";
			} else {
				if (const_var.a_p_d_a.length > 0 && const_var.a_p_d_a.panel.length == 0) {
					params.p_l_w = "Close";
				} else {
					params.p_l_w = params.p_l_w > calVal ? params.p_l_w : calVal.toString();
				}
			}
		} else {
			if (params.p_l_w == "Half_Close" || params.p_l_w == "One_Fourth_Close" || params.p_l_w == "Three_Fourth_Close") {
				params.p_l_w = params.a_c_p_l == true ? params.p_l_w : params.p_l_w;
			} else {
				params.p_l_w = params.a_c_p_l == true ? params.p_l_w : "Open";
			}
		}
	}
	const wallData = calculateLeanWallData({
		sideWall: params.p_b_c_b_l,
		sideWallRear: params.p_b_c_b_l_r,
		endWallFront: params.p_b_c_b_l_f,
		endWallBack: params.p_b_c_b_l_b,
		isStorage: params.add_storage_check,
		storagePosition: params.leftLeanStoragePosition,
		storageLength: params.add_storage,
		leanDepth: params.lean_p_d,
		leanStyle: params.leanStyle.left
	});

	updateLeanWallData({
		wallKey: "leftLean",
		wallData,
		walls: {
			p_b_c_b_l: params.p_b_c_b_l,
			p_b_c_b_l_f: params.p_b_c_b_l_f,
			p_b_c_b_l_b: params.p_b_c_b_l_b,
			p_b_c_b_l_r: params.p_b_c_b_l_r
		}
	});

	finalizeLeanUpdate();
};

export const UpdateRightLean = (type) => {
	if (params.add_right_lean == true && params.p_r_w != "Close") {
		var pitchCalulation = (params.leanR_p_w * params.b_l_t_r_pR) / 12;
		var calData = params.leanStyle.right === "gable" ? 0 : (params.leanR_p_w * params.b_l_t_r_pR) / 12;
		var finalHeight = params.leanStyle.right === "gable" ? params.p_h - params.leanR_p_h : params.p_h - (calData + params.leanR_p_h);
		var calVal = Math.ceil(finalHeight / 3);
		var oneFourthValue = params.p_h / 4;
		var oneFourthValue = params.p_h / 2;
		var halfCloseValue = params.p_h / 2;
		if (oneFourthValue < finalHeight && halfCloseValue < finalHeight && params.p_l_w !== "Three_Fourth_Close" /*|| (2 * oneFourthValue) < finalHeight || (3 * oneFourthValue) < finalHeight*/) {
			params.p_r_w = params.p_r_w > calVal ? params.p_r_w : calVal.toString();
		}
		if (calVal > 0 && params.p_r_w !== "Half_Close" && params.p_r_w !== "One_Fourth_Close" && params.p_r_w !== "Three_Fourth_Close") {
			if (params.p_h == calData + params.leanR_p_h) {
				params.p_r_w = "Open";
			} else {
				if (const_var.a_p_d_a.length > 0 && const_var.a_p_d_a.panel.length == 0) {
					params.p_r_w = "Close";
				} else {
					params.p_r_w = params.p_r_w > calVal ? params.p_r_w : calVal.toString();
				}
			}
		} else {
			if (params.p_r_w == "Half_Close" || params.p_r_w == "One_Fourth_Close" || params.p_r_w == "Three_Fourth_Close") {
				params.p_r_w = params.a_c_p_r == true ? params.p_r_w : params.p_r_w;
			} else {
				params.p_r_w = params.a_c_p_r == true ? params.p_r_w : "Open";
			}
		}
	}
	const wallData = calculateLeanWallData({
		sideWall: params.p_b_c_b_r,
		sideWallRear: params.p_b_c_b_r_r,
		endWallFront: params.p_b_c_b_r_f,
		endWallBack: params.p_b_c_b_r_b,
		isStorage: params.add_storage_check_right,
		storagePosition: params.rightLeanStoragePosition,
		storageLength: params.add_storage_right,
		leanDepth: params.leanR_p_d,
		leanStyle: params.leanStyle.right
	});

	updateLeanWallData({
		wallKey: "rightLean",
		wallData,
		walls: {
			p_b_c_b_r: params.p_b_c_b_r,
			p_b_c_b_r_f: params.p_b_c_b_r_f,
			p_b_c_b_r_b: params.p_b_c_b_r_b,
			p_b_c_b_r_r: params.p_b_c_b_r_r
		}
	});

	finalizeLeanUpdate();
};

export const UpdateFrontLean = (type) => {
	let mainIndexF;
	let fHight = params.leanStyle.front === "standard" ? params.p_h - (params.leanF_p_h + (parseInt(params.b_l_t_r_pF) / 12) * params.leanF_p_w) : params.p_h - params.leanF_p_h;
	if (params.add_front_lean == true && fHight > 0) {
		let orignalObj = const_var.wallArray["front"];
		let orignalObjKeys = Object.keys(const_var.wallArray["front"]);
		let fristAvailableKey = orignalObjKeys.includes("Open") ? orignalObj[orignalObjKeys[1]] : orignalObj[orignalObjKeys[0]];

		Object.entries(const_var.wallArray["front"]).forEach(([key, value], index) => {
			if (fHight < 2.5 && const_var.a_p_d_a.gable_end != undefined && const_var.a_p_d_a.gable_end.length > 0) {
				if (params.leanStyle.front === "gable" && params.p_h === params.leanF_p_h && params.p_w === params.leanF_p_w && params.p_r_p == params.b_l_t_r_pF) {
					params.p_f_wF = "Open";
				} else {
					params.p_f_wF = "Gable";
				}
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			} else if (fHight >= 2.5 && fHight <= 3.5 && const_var.a_p_d_a.gable_end[0] != undefined && (const_var.a_p_d_a.gable_end[0].extended != 0 || const_var.a_p_d_a.gable_end[0].vertical_extended != 0)) {
				params.p_f_wF = "Extended Gable";
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			} else if (
				(fHight > 3.5 && fHight <= params.p_h / 4) ||
				(fristAvailableKey == "One_Fourth_Close" && fHight <= 3.5) ||
				(const_var.a_p_d_a.gable_end[0] != undefined && fHight >= 2.5 && fHight <= 3.5 && const_var.a_p_d_a.gable_end[0].extended == 0) ||
				(const_var.a_p_d_a.gable_end[0] != undefined && fHight >= 2.5 && fHight <= 3.5 && const_var.a_p_d_a.gable_end[0].vertical_extended == 0)
			) {
				params.p_f_wF = "One_Fourth_Close";
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			} else if ((fHight > params.p_h / 4 && fHight <= params.p_h / 2) || (fristAvailableKey == "Half_Close" && fHight <= params.p_h / 4)) {
				params.p_f_wF = "Half_Close";
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			} else if ((fHight > params.p_h / 2 && fHight <= params.p_h * (3 / 4)) || (fristAvailableKey == "Three_Fourth_Close" && fHight <= params.p_h / 2)) {
				params.p_f_wF = "Three_Fourth_Close";
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			} else {
				params.p_f_wF = "Close";
				if (params.p_f_wF == value) {
					mainIndexF = index;
				}
				if (index >= mainIndexF) {
					const_var.wallArray["front"][key] = value;
				} else {
					delete const_var.wallArray["front"][key];
				}
			}
		});

		if (Object.values(const_var.wallArray["front"]).includes(params.p_f_w) == false && Object.values(const_var.wallArray["front"]).length != 0) {
			params.p_f_w = params.p_f_wF;
		}
	}
	const wallData = calculateLeanWallData({
		sideWall: params.p_b_c_b_f_l,
		sideWallRear: params.p_b_c_b_f_r,
		endWallFront: params.p_b_c_b_f_f,
		endWallBack: params.p_b_c_b_f_b,
		isStorage: params.add_storage_check_front,
		storagePosition: params.frontLeanStoragePosition,
		storageLength: params.add_storage_front,
		leanDepth: params.leanF_p_d,
		leanStyle: params.leanStyle.front
	});

	updateLeanWallData({
		wallKey: "frontLean",
		wallData,
		walls: {
			p_b_c_b_f_l: params.p_b_c_b_f_l,
			p_b_c_b_f_f: params.p_b_c_b_f_f,
			p_b_c_b_f_b: params.p_b_c_b_f_b,
			p_b_c_b_f_r: params.p_b_c_b_f_r
		}
	});

	finalizeLeanUpdate();
};
export const UpdateBackLean = (type) => {
	let bHight = params.leanStyle.back === "standard" ? params.p_h - (params.leanB_p_h + (parseInt(params.b_l_t_r_pB) / 12) * params.leanB_p_w) : params.p_h - params.leanB_p_h;
	let mainIndexB;
	if (params.add_back_lean == true && bHight > 0) {
		let orignalObj = const_var.wallArray["back"];
		let orignalObjKeys = Object.keys(const_var.wallArray["back"]);
		let fristAvailableKey = orignalObjKeys.includes("Open") ? orignalObj[orignalObjKeys[1]] : orignalObj[orignalObjKeys[0]];

		Object.entries(const_var.wallArray["back"]).forEach(([key, value], index) => {
			if (bHight < 2.5 && const_var.a_p_d_a.gable_end != undefined && const_var.a_p_d_a.gable_end.length > 0) {
				if (params.leanStyle.back === "gable" && params.p_h === params.leanB_p_h && params.p_w === params.leanB_p_w && params.p_r_p == params.b_l_t_r_pB) {
					params.p_f_wB = "Open";
				} else {
					params.p_b_wB = "Gable";
				}
				if (params.p_b_wB == value) {
					mainIndexB = index;
				}
				if (index >= mainIndexB) {
					const_var.wallArray["back"][key] = value;
				} else {
					delete const_var.wallArray["back"][key];
				}
			} else if (bHight >= 2.5 && bHight <= 3.5 && const_var.a_p_d_a.gable_end[0] != undefined && (const_var.a_p_d_a.gable_end[0].extended != 0 || const_var.a_p_d_a.gable_end[0].vertical_extended != 0)) {
				params.p_b_wB = "Extended Gable";
				if (params.p_b_wB == value) {
					mainIndexB = index;
				}
				if (index >= mainIndexB) {
					const_var.wallArray["back"][key] = value;
				} else {
					delete const_var.wallArray["back"][key];
				}
			} else if (
				(bHight > 3.5 && bHight <= params.p_h / 4) ||
				(fristAvailableKey == "One_Fourth_Close" && bHight <= 3.5) ||
				(const_var.a_p_d_a.gable_end[0] != undefined && bHight >= 2.5 && bHight <= 3.5 && const_var.a_p_d_a.gable_end[0].extended == 0) ||
				(const_var.a_p_d_a.gable_end[0] != undefined && bHight >= 2.5 && bHight <= 3.5 && const_var.a_p_d_a.gable_end[0].vertical_extended == 0)
			) {
				params.p_b_wB = "One_Fourth_Close";
				if (params.p_b_wB == value) {
					mainIndexB = index;
				}
				if (index >= mainIndexB) {
					const_var.wallArray["back"][key] = value;
				} else {
					delete const_var.wallArray["back"][key];
				}
			} else if ((bHight > params.p_h / 4 && bHight <= params.p_h / 2) || (fristAvailableKey == "Half_Close" && bHight <= params.p_h / 4)) {
				params.p_b_wB = "Half_Close";
				if (params.p_b_wB == value) {
					mainIndexB = index;
				}
				if (index >= mainIndexB) {
					const_var.wallArray["back"][key] = value;
				} else {
					delete const_var.wallArray["back"][key];
				}
			} else if ((bHight > params.p_h / 2 && bHight <= params.p_h * (3 / 4)) || (fristAvailableKey == "Three_Fourth_Close" && bHight <= params.p_h / 2)) {
				params.p_b_wB = "Three_Fourth_Close";
			} else {
				params.p_b_wB = "Close";
				if (params.p_b_wB == value) {
					mainIndexB = index;
				}
				if (index >= mainIndexB) {
					const_var.wallArray["back"][key] = value;
				} else {
					delete const_var.wallArray["back"][key];
				}
			}
		});

		if (Object.values(const_var.wallArray["back"]).includes(params.p_b_w) == false && Object.values(const_var.wallArray["back"]).length != 0) {
			params.p_b_w = params.p_b_wB;
		}
	}
	const wallData = calculateLeanWallData({
		sideWall: params.p_b_c_b_b_l,
		sideWallRear: params.p_b_c_b_b_r,
		endWallFront: params.p_b_c_b_b_f,
		endWallBack: params.p_b_c_b_b_b,
		isStorage: params.add_storage_check_back,
		storagePosition: params.backLeanStoragePosition,
		storageLength: params.add_storage_back,
		leanDepth: params.leanB_p_d,
		leanStyle: params.leanStyle.back
	});

	updateLeanWallData({
		wallKey: "backLean",
		wallData,
		walls: {
			p_b_c_b_b_l: params.p_b_c_b_b_l,
			p_b_c_b_b_f: params.p_b_c_b_b_f,
			p_b_c_b_b_b: params.p_b_c_b_b_b,
			p_b_c_b_b_r: params.p_b_c_b_b_r
		}
	});

	const_var.UpdatedPriceData.back_lean_insulation_price_changed = true;

	finalizeLeanUpdate();
};

export const ConvStr = (str) => {
	return typeof str === "string" ? str.toLowerCase() : str;
};
const convertToNumber = (price) => {
	return +(Math.round(price + "e+2") + "e-2");
};

const convertToTwoDecimalNumber = (price) => {
	price = parseFloat(price);
	let convertToTwoDecimal = Number.isInteger(price) ? price : price.toFixed(2);
	let convertToNumberValue = parseFloat(convertToTwoDecimal);

	return convertToNumberValue;
};

function FindStringByName(arr, str) {
	for (var i = 0; i <= arr.length - 1; i++) {
		if (arr[i].name.includes(str)) {
			return i;
		}
	}
	return "false";
}
const { CheckLeanLegsByResponseForCompare, CheckLegsByResponseForCompare, CheckLegsByResponse, CheckLeanLegsByResponse } = createLegsConditionHelpers(() => ({
	BuildingUpdate
}));

const { cPforRLeanOnlyComparision, cPforFLeanOnlyComparision, cPforBLeanOnlyComparision, cPforLLeanOnlyComparision, setComparePricingData } = createCompareLeanPricingHelpers(() => ({
	ConvStr,
	removeDataFromArrayCompare,
	convertToTwoDecimalNumber,
	calcOverhangSize,
	filtterArrayElements
}));

export {
	CheckLeanLegsByResponseForCompare,
	CheckLegsByResponseForCompare,
	CheckLegsByResponse,
	CheckLeanLegsByResponse,
	cPforRLeanOnlyComparision,
	cPforFLeanOnlyComparision,
	cPforBLeanOnlyComparision,
	cPforLLeanOnlyComparision,
	setComparePricingData
};

const { cP } = createCenterBuildingPriceCalculationHelpers(() => ({
	ConvStr,
	calculateDoorComponentPrice,
	calcPriceWithCostType,
	convertToTwoDecimalNumber,
	filtterArrayElements,
	isCustomInsulation,
	makeCertificateArrayLeft,
	makeCertificateArray,
	removeDataFromArray,
	setInsulation,
	uUdD,
	leanuUdD
}));

export { cP };

const { cPforFLeanOnly, cPforBLeanOnly, cPforLLeanOnly, cPforRLeanOnly } = createLeanBuildingPriceCalculationHelpers(() => ({
	ConvStr,
	removeDataFromArray,
	convertToTwoDecimalNumber,
	cP,
	setInsulation,
	calcOverhangSize,
	commonFunctionForColor,
	isCustomInsulation
}));

export { cPforFLeanOnly, cPforBLeanOnly, cPforLLeanOnly, cPforRLeanOnly };

const calcPriceWithCostType = (item, leantoPriceCalculation = {}) => {
	if (!item) {
		return 0;
	}

	const itemCost = parseFloat(item.cost || 0);
	if (item.cost_type !== "%") {
		return itemCost;
	}

	const splitVal = Array.isArray(item.price_of) ? item.price_of : typeof item.price_of === "string" && item.price_of !== "" ? item.price_of.split(",") : 0;

	let baseValue = 0;
	if (splitVal && splitVal.includes) {
		if (splitVal.includes("full_building_price")) {
			baseValue += parseFloat(leantoPriceCalculation.totalLeanPrice || 0);
		}
		if (splitVal.includes("base_price")) {
			baseValue += parseFloat(leantoPriceCalculation.totalBasePrice || 0);
		}
		if (splitVal.includes("wall_price")) {
			baseValue += parseFloat(leantoPriceCalculation.totalWallPrice || 0);
			baseValue += parseFloat(leantoPriceCalculation.totalEndWallPrice || 0);
		}
	} else {
		baseValue += parseFloat(leantoPriceCalculation.totalBasePrice || 0);
	}

	return (baseValue * itemCost) / 100;
};

export const calculateDoorComponentPrice = (flag, indexVal, chkVal) => {
	if (flag == true && const_var.entry_points.length > 0) {
		let value = const_var.entry_points[indexVal];
		let dataPriceC = 0;
		dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_price);

		if (value.entry_header_seal == true) {
			dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_header_seal_price);
		} else {
			dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
		}

		if (value.entry_trim_kit == true) {
			dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_trim_kit_price);
		} else {
			dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
		}

		if (value.entry_chain_hoist == true) {
			dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_chain_hoist_price);
		} else {
			dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
		}

		if (value.entry_automatic_openers == true) {
			dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_automatic_openers_price);
		} else {
			dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
		}
		dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_garageDoor_color_price == undefined ? 0 : Number(value.entry_garageDoor_color_price));

		const_var.BuildingPriceArrar["Component_total"] =
			const_var.BuildingPriceArrar["Component_total"] != undefined ? parseFloat(const_var.BuildingPriceArrar["Component_total"]) + parseFloat(dataPriceC) : 0 + parseFloat(dataPriceC);

		if (chkVal != undefined) {
			const_var.BuildingPriceArrar["order_total"] =
				const_var.BuildingPriceArrar["order_total"] != undefined ? parseFloat(const_var.BuildingPriceArrar["order_total"]) + parseFloat(dataPriceC) : const_var.BuildingPriceArrar["order_total"] + 0;
			const_var.post_data.building.order_total = parseFloat(const_var.post_data.building.order_total) + parseFloat(dataPriceC);
		}
		return parseFloat(const_var.BuildingPriceArrar["Component_total"]);
	} else {
		if (const_var.entry_points.length > 0) {
			let dataPriceC = 0;
			const_var.entry_points.map((value, key) => {
				dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_price);
				if (value.entry_header_seal == true) {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_header_seal_price);
				} else {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
				}

				if (value.entry_trim_kit == true) {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_trim_kit_price);
				} else {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
				}

				if (value.entry_chain_hoist == true) {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_chain_hoist_price);
				} else {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
				}

				if (value.entry_automatic_openers == true) {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_automatic_openers_price);
				} else {
					dataPriceC = parseFloat(dataPriceC) + parseFloat(0);
				}
				dataPriceC = parseFloat(dataPriceC) + parseFloat(value.entry_garageDoor_color_price == undefined ? 0 : Number(value.entry_garageDoor_color_price));
			});
			const_var.BuildingPriceArrar["Component_total"] =
				const_var.BuildingPriceArrar["Component_total"] != undefined ? parseFloat(const_var.BuildingPriceArrar["Component_total"]) + parseFloat(dataPriceC) : 0 + parseFloat(dataPriceC);
			return parseFloat(dataPriceC);
		} else {
			return parseFloat(0);
		}
	}
};

export const filtterArrayElements = () => {
	var Leantoresult = [];
	if (const_var.post_data.building != undefined) {
		Leantoresult = const_var.UpdatedPriceData?.leanto?.filter(function (item, pos, self) {
			return self.indexOf(item) == pos;
		});
	}
	const_var.UpdatedPriceData.leanto = Leantoresult;
};

const isCustomInsulation = (leanType) => {
	return params.p_c_i;
};

export const uUdD = () => {
	let drop_arr = {};
	params.p_u_t = params.p_u_t > const_var.DistanceArr[params.p_b_t][params.p_r_s] ? params.p_u_t : const_var.DistanceArr[params.p_b_t][params.p_r_s];

	const numberofOption = Math.floor((params.p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]);

	for (let i = 1; i <= numberofOption; i++) {
		params.add_storage = params.add_storage < params.lean_p_d ? params.add_storage : 1 * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		const feetLabel = `${i * const_var.DistanceArr[params.p_b_t][params.p_r_s]} Feet`;
		const feetValue = i * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		const_var.LeftLeandrop_arr[feetLabel] = feetValue;
		drop_arr[feetLabel] = feetValue;
	}

	const_var.b_u_D_p_a = drop_arr;
	if (typeof cuComponent.handleComponentPositionOnDimensionChange === "function") {
		cuComponent.handleComponentPositionOnDimensionChange();
	}
};

export const leanuUdD = () => {
	const numberofOption = Math.floor((params.lean_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]);
	const numberofOptionF = Math.floor((params.leanF_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]);
	const numberofOptionB = Math.floor((params.leanB_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]);
	const numberofOptionR = Math.floor((params.leanR_p_d - const_var.DistanceArr[params.p_b_t][params.p_r_s]) / const_var.DistanceArr[params.p_b_t][params.p_r_s]);

	const_var.LeftLeandrop_arr = {};
	for (let i = 1; i <= numberofOption; i++) {
		params.add_storage = params.add_storage < params.lean_p_d ? params.add_storage : 1 * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		const_var.LeftLeandrop_arr[`${i * const_var.DistanceArr[params.p_b_t][params.p_r_s]} Feet`] = i * const_var.DistanceArr[params.p_b_t][params.p_r_s];
	}

	const_var.RightLeandrop_arr = {};
	for (let i = 1; i <= numberofOptionR; i++) {
		params.add_storage_right = params.add_storage_right < params.leanR_p_d ? params.add_storage_right : 1 * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		const_var.RightLeandrop_arr[`${i * const_var.DistanceArr[params.p_b_t][params.p_r_s]} Feet`] = i * const_var.DistanceArr[params.p_b_t][params.p_r_s];
	}

	const_var.FrontLeandrop_arr = {};
	for (let i = 1; i <= numberofOptionF; i++) {
		params.add_storage_front = params.add_storage_front < params.leanF_p_d ? params.add_storage_front : 1 * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		const_var.FrontLeandrop_arr[`${i * const_var.DistanceArr[params.p_b_t][params.p_r_s]} Feet`] = i * const_var.DistanceArr[params.p_b_t][params.p_r_s];
	}

	const_var.BackLeandrop_arr = {};
	for (let i = 1; i <= numberofOptionB; i++) {
		params.add_storage_back = params.add_storage_back < params.leanF_p_d ? params.add_storage_back : 1 * const_var.DistanceArr[params.p_b_t][params.p_r_s];
		const_var.BackLeandrop_arr[`${i * const_var.DistanceArr[params.p_b_t][params.p_r_s]} Feet`] = i * const_var.DistanceArr[params.p_b_t][params.p_r_s];
	}
};

export const uBmLDimension = () => {
	if (params.add_left_lean === true) {
		if (params.p_h < const_var.b_m_i_hlean + parseInt(params.b_l_t_r_p)) {
			const heig = const_var.b_m_i_hlean + parseInt(params.b_l_t_r_p);
			params.p_h = heig <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height ? heig : const_var.roofObject[params.p_b_t][params.p_r_s].max_height;
		}
	} else if (params.add_right_lean === true) {
		if (params.p_h < const_var.b_m_i_hlean + parseInt(params.b_l_t_r_pR)) {
			const heig = const_var.b_m_i_hlean + parseInt(params.b_l_t_r_pR);
			params.p_h = heig <= const_var.roofObject[params.p_b_t][params.p_r_s].max_height ? heig : const_var.roofObject[params.p_b_t][params.p_r_s].max_height;
		}
	} else {
		params.p_h = params.p_h < const_var.b_m_i_h ? const_var.b_m_i_h : params.p_h;
	}

	cP(const_var.a_p_d_a);
};

export const uUdDCB = () => {
	params.cB_addStorage_right = params.cB_addStorage_right > const_var.DistanceArr[params.p_b_t][params.p_r_s] ? params.cB_addStorage_right : const_var.DistanceArr[params.p_b_t][params.p_r_s];

	const drop_arr = {};
	const values = const_var.b_u_D_p_a6 || [];

	for (let i = 0; i <= values.length; i++) {
		if (values[i] < params.p_w) {
			drop_arr[`${values[i]} Feet`] = values[i];
		}
	}

	if (drop_arr[`${params.cB_addStorage_right} Feet`] === undefined) {
		params.cB_addStorage_check_right = false;
	}

	const_var.b_u_D_p_a_c_b = drop_arr;
};

export const makeExtraElements = () => {
	const dataNew = const_var.a_p_d_a;

	if (!dataNew) {
		return;
	}

	const_var.main_gauge_arr = {};
	if (Array.isArray(dataNew.base)) {
		dataNew.base.forEach((item) => {
			if (!item) {
				return;
			}

			const_var.main_gauge_arr[`${item.gauge} Gauge`] = item.gauge;
			params.gauge_val = params.gauge_val === "" ? item.gauge : params.gauge_val;
		});
	}

	const_var.trsArr = { 0: "Select" };
	if (Array.isArray(dataNew.trusses) && dataNew.trusses.length > 0) {
		if (dataNew.trusses[0].height === 0) {
			dataNew.trusses.forEach((item) => {
				if (item) {
					const_var.trsArr[item.cost] = item.truss;
				}
			});
		}
	} else {
		params.p_t_u = 0;
	}

	if (Array.isArray(dataNew.insulation) && dataNew.insulation.length > 0) {
		const_var.insulationJson[0] = "Select";
		dataNew.insulation.forEach((item) => {
			if (!item) {
				return;
			}

			const_var.insulationJson[item.insulation_id] = item.name;
			const_var.insulationPriceJson[item.insulation_id] = item;
		});
	}
};

export const makeInsulationArrayForLeanto = () => {
	const populateLeanInsulation = (leanData, targetArray) => {
		if (!leanData || leanData === "" || !Array.isArray(leanData.insulation)) {
			return;
		}

		leanData.insulation.forEach((item) => {
			if (item && item.insulation_id !== undefined) {
				targetArray[item.insulation_id] = item;
			}
		});
	};

	populateLeanInsulation(const_var.leanGetDataLeft, const_var.insulationArrayForLeantoLeft);
	populateLeanInsulation(const_var.leanGetDataFront, const_var.insulationArrayForLeantoFront);
	populateLeanInsulation(const_var.leanGetDataBack, const_var.insulationArrayForLeantoBack);
	populateLeanInsulation(const_var.leanGetDataRight, const_var.insulationArrayForLeantoRight);
};

export const removeDataFromArray = (val) => {
	for (var i = 0; i <= const_var.leanto.length - 1; i++) {
		if (const_var.leanto[i].leanto_type == val) {
			const_var.leanto.splice(i, 1);
			if (const_var.UpdatedPriceData != undefined && const_var.UpdatedPriceData?.leanto != undefined) {
				const_var.UpdatedPriceData.leanto.splice(i, 1);
			}
		}
	}
};

export const removeDataFromArrayCompare = (val) => {
	for (var i = 0; i <= const_var.leantoCompare.length - 1; i++) {
		if (const_var.leantoCompare[i].leanto_type == val) {
			const_var.leantoCompare.splice(i, 1);
		}
	}
};

export const IsNumeric = (newVal) => /^-{0,1}\d*\.{0,1}\d+$/.test(newVal);

export const makeCertificateArrayLeft = (type) => {
	const_var.c_f_aCerLean[type] = [];
	if (type == "left") {
		const_var.leftCertArr = {};
		const_var.leftCertArr["Select"] = 0;
		if (const_var.loginSession == true) {
			const_var.leftCertArr["Other Rating/Certification"] = "other";
		}
	}
	if (type == "front") {
		const_var.frontCertArr = {};
		const_var.frontCertArr["Select"] = 0;
		if (const_var.loginSession == true) {
			const_var.frontCertArr["Other Rating/Certification"] = "other";
		}
	}
	if (type == "back") {
		const_var.backCertArr = {};
		const_var.backCertArr["Select"] = 0;
		if (const_var.loginSession == true) {
			const_var.backCertArr["Other Rating/Certification"] = "other";
		}
	}
	if (type == "right") {
		const_var.rightCertArr = {};
		const_var.rightCertArr["Select"] = 0;
		if (const_var.loginSession == true) {
			const_var.rightCertArr["Other Rating/Certification"] = "other";
		}
	}
};

export const makeCertificateArray = (from = undefined) => {
	const_var.c_f_a = [];
	const_var.c_f_a_per = [];
	const_var.c_f_a_sCer = [];
	const_var.c_f_aCer = [];
	const_var.c_f_i_a = [];
	const_var.main_extraItems_arr = { Select: "Select" };
	const_var.c_f_b_a = [];
	const_var.e_i_a = [];
	var data = const_var.a_p_d_a;
	params.p_e_i = params.p_e_i != "" ? params.p_e_i : "Select";
	let legChk = params.p_e_l == true ? 1 : 0;
	const_var.isUtilityChanges = false;
	const_var.isUtilityLengthChange = false;
	if (const_var.loginSession == true) {
		if (const_var.b_o_J_1[params.p_b_t] == "Custom Buildings") {
		}
		const_var.main_extraItems_arr["Other Rating/Certification"] = "other";
	}
};
export const addComponent = (state, editData) => {
	if (!editData || !Array.isArray(editData.entry_points) || editData.entry_points.length === 0) {
		params.doorType = "Garage";
		return;
	}

	const_var.sum = 0;

	for (let i = 0; i < editData.entry_points.length; i++) {
		const entryPoint = editData.entry_points[i];

		if (!entryPoint) {
			continue;
		}

		params.trimkit = entryPoint.entry_trim_kit !== undefined ? entryPoint.entry_trim_kit : params.trimkit;
		params.chain_hoist = entryPoint.entry_chain_hoist !== undefined ? entryPoint.entry_chain_hoist : params.chain_hoist;
		params.header_seal = entryPoint.entry_header_seal !== undefined ? entryPoint.entry_header_seal : params.header_seal;
		params.automatic_openers = entryPoint.entry_automatic_openers !== undefined ? entryPoint.entry_automatic_openers : params.automatic_openers;
		params.certified_door = entryPoint.entry_certified !== undefined ? entryPoint.entry_certified : params.certified_door;
		params.extra_notes = entryPoint.entry_note !== undefined ? entryPoint.entry_note : params.extra_notes;
		cuComponent.RemoveDoorComponent(
			entryPoint.uniqueId,
			entryPoint.entry_type,
			entryPoint.component_name,
			entryPoint.component_wall_name,
			entryPoint,
			entryPoint.parent_array_key,
			entryPoint.child_array_key,
			entryPoint.nested_array_key,
			entryPoint.entry_rotation,
			entryPoint.entry_position,
			"",
			entryPoint.entry_size
		);
	}

	params.doorType = "Garage";
};

export const upperCaseFirst = (str) => {
	if (typeof str == "string") {
		return str.charAt(0).toUpperCase() + str.substring(1);
	} else {
		return str;
	}
};

export const converImageIntoBase64 = (url, callback) => {
	var xhr = new XMLHttpRequest();
	xhr.onload = function () {
		var reader = new FileReader();
		reader.onloadend = function () {
			callback(reader.result);
		};
		reader.readAsDataURL(xhr.response);
	};
	xhr.open("GET", url);
	xhr.responseType = "blob";
	xhr.send();
};

export default pricingReducer;
